import { pushToDataLayer } from '@app/infrastructure/gtm/pushToDataLayer';
import { GtmEventName } from '@app/domain/model/gtm/GtmEventName';
import { GtmInsuranceType } from '@app/domain/model/gtm/GtmInsuranceType';

export interface HomeStartCalculationData {
    address: string;
}

export function trackStartCalculation(data: HomeStartCalculationData): void {
    pushToDataLayer(GtmEventName.StartCalculation, {
        insurance_type: GtmInsuranceType.Home,
        address: data.address,
    });
}
